const comments = [
  {
    id: 1,
    name: '风之追番人',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20portrait%20avatar%20of%20a%20young%20person%20with%20bright%20eyes%20and%20warm%20smile%2C%20soft%20pastel%20colors%2C%20simple%20flat%20illustration%20style%2C%20circular%20frame%2C%20clean%20minimalist%20design%2C%20friendly%20expression%2C%20light%20warm%20background&width=120&height=120&seq=avatar-01&orientation=squarish',
    text: '用91樱花追了三年番了，资源真的全，更新速度也没得说。每周五等鬼灭更新是我最期待的事！',
    time: '2天前',
    tag: '资深用户',
  },
  {
    id: 2,
    name: '樱花下的约定',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20avatar%20of%20a%20girl%20with%20pink%20hair%20and%20gentle%20smile%2C%20cherry%20blossom%20petals%20background%2C%20soft%20kawaii%20illustration%2C%20circular%20frame%2C%20warm%20pastel%20pink%20tones%2C%20clean%20design&width=120&height=120&seq=avatar-02&orientation=squarish',
    text: '从微博推荐过来的，没想到国内还有这么好的动漫网站！下载速度超快，画质也清晰，推荐给所有二次元朋友。',
    time: '5天前',
    tag: '新用户',
  },
  {
    id: 3,
    name: '夜月下的猫咪',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20avatar%20of%20a%20person%20with%20dark%20hair%20and%20mysterious%20expression%2C%20moonlight%20theme%2C%20cool%20purple%20and%20silver%20tones%2C%20simple%20flat%20illustration%2C%20circular%20frame%2C%20clean%20design&width=120&height=120&seq=avatar-03&orientation=squarish',
    text: '国漫区越来越强了！《凡人修仙传》《完美世界》都在这里追，弹幕氛围也很好，不像其他站那么乱。',
    time: '1周前',
    tag: '国漫粉',
  },
  {
    id: 4,
    name: '追番不眠夜',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20avatar%20of%20a%20person%20with%20glasses%20and%20warm%20smile%2C%20nerdy%20cute%20vibe%2C%20soft%20blue%20and%20cream%20tones%2C%20simple%20illustration%2C%20circular%20frame%2C%20clean%20design&width=120&height=120&seq=avatar-04&orientation=squarish',
    text: '最良心的是无删减版，之前在其他平台看的总觉得少了什么，这里全是完整版，追番体验直接拉满！',
    time: '3天前',
    tag: '追番达人',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            追番伙伴的真实评价
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            来自91樱花用户的使用反馈，看看他们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-accent-200/60 transition-all duration-300 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</div>
                  <span className="inline-block text-[10px] px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 font-medium mt-0.5">
                    {comment.tag}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-3">
                {comment.text}
              </p>
              <div className="text-xs text-foreground-400 flex items-center gap-2">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-time-line text-xs"></i>
                </div>
                {comment.time}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}